__turbopack_context__.v({
  "close": "Modal-module-scss-module__k1ZY8q__close",
  "content": "Modal-module-scss-module__k1ZY8q__content",
  "header": "Modal-module-scss-module__k1ZY8q__header",
  "modal": "Modal-module-scss-module__k1ZY8q__modal",
  "overlay": "Modal-module-scss-module__k1ZY8q__overlay",
  "title": "Modal-module-scss-module__k1ZY8q__title",
});
